import { observer } from "mobx-react-lite";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useStore } from "../../Store";
import LogoModel from "../LogoModel";

const ContactPage = () => {
  const { casesStore } = useStore();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const presentation = casesStore.presentation;

  if (!presentation) return null;

  return (
    <div id="ContactPage">
      <div id="Header">
        <div id="HeaderContainer">
          <LogoModel />
          <button type="button" className="contact-page-close-button"
            aria-label="Back" onClick={() => navigate("/app")} />
        </div>
      </div>
      <div id="contact-page-body">
        <div className="contact-body-block">
          <div className={`contact-body-block-header product-font-${presentation.brand}`}>
            {t("ContactPageHeader1")}
          </div>
          {presentation.contactPagePhone.trim() && (
            <a className={`contact-body-block-text product-font-${presentation.brand}`}
              href={`tel:${presentation.contactPagePhone.replace(/\s/g, "")}`}>
              {presentation.contactPagePhone}
            </a>
          )}
        </div>
        {presentation.claimLink && (
          <div className={`contact-body-block-2-${i18n.language} product-font-${presentation.brand}`}>
            <div className="contact-body-block-header-2">{t("ChatBotHeader")}</div>
            <a className={`contact-page-chatbot-button p-${presentation.brand}`}
              href={presentation.claimLink} target="_blank" rel="noopener noreferrer">
              {t("ChatBotButton")}
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default observer(ContactPage);
